import { solutionURL } from '../endpoints';

function SolutionService( { access_token } ) {
    const fetchWithAuth = function( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };


    const listSolutions = async () => {
        const res = await fetchWithAuth( `${ solutionURL }/services/v1/solutions`, {
            headers: {
                'content-type': 'application/json'
            }
        } );

        const json = await res.json();
        return json.solutions;
    };


    return {
        listSolutions
    };
}

export default SolutionService;

